import type { DataSchema } from 'types';
import { TABLE_CELL_TYPE } from 'types/enums';

export const userDetailDataScheme = {
  id: {
    type: TABLE_CELL_TYPE.ID,
    label: 'id',
    translationKey: 'table.header.id',
  },
  roleId: {
    type: TABLE_CELL_TYPE.ID,
    label: 'hidden',
    translationKey: 'table.header.id',
  },
  name: {
    type: TABLE_CELL_TYPE.TEXT,
    label: 'name',
    translationKey: 'table.header.name',
  },
  validFrom: {
    type: TABLE_CELL_TYPE.DATE,
    label: 'validFrom',
    translationKey: 'table.header.validFrom',
  },
  validUntil: {
    type: TABLE_CELL_TYPE.DATE,
    label: 'validUntil',
    translationKey: 'table.header.validTo',
  },
  status: {
    type: TABLE_CELL_TYPE.STATUS,
    label: 'status',
    translationKey: 'table.header.status',
  },
} satisfies DataSchema;

export const usersDataScheme = {
  id: {
    label: 'id',
    type: TABLE_CELL_TYPE.ID,
    translationKey: 'table.header.id',
    hidden: true,
  },
  fullName: {
    label: 'fullName',
    type: TABLE_CELL_TYPE.USERNAME,
    translationKey: 'table.header.fullName',
  },
  email: {
    label: 'email',
    type: TABLE_CELL_TYPE.EMAIL,
    translationKey: 'table.header.email',
  },
  contactEmail: {
    label: 'contactEmail',
    type: TABLE_CELL_TYPE.EMAIL,
    translationKey: 'table.header.contactEmail',
  },
  status: {
    label: 'status',
    type: TABLE_CELL_TYPE.MULTI_SELECT,
    translationKey: 'table.header.status',
  },
  validFrom: {
    label: 'activeFrom',
    type: TABLE_CELL_TYPE.DATE,
    groupName: 'from',
    groupOrder: 1,
    group: 'Date',
    translationKey: 'table.header.validFrom',
  },
  dateOfDeactivation: {
    label: 'dateOfDeactivation',
    type: TABLE_CELL_TYPE.DATE,
    groupName: 'to',
    groupOrder: 2,
    group: 'Date',
    translationKey: 'table.header.dateOfDeactivation',
  },
  dateOfActivation: {
    label: 'dateOfActivation',
    type: TABLE_CELL_TYPE.DATE,
    groupName: 'from',
    groupOrder: 1,
    group: 'Date',
    translationKey: 'table.header.dateOfActivation',
    hidden: true,
  },
  userRoles: {
    label: 'userRoles',
    type: TABLE_CELL_TYPE.NAME_ARRAY,
    translationKey: 'table.header.roles',
  },
  reference: {
    label: 'reference',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.reference',
  },
  availablePermissions: {
    label: 'availablePermissions',
    type: TABLE_CELL_TYPE.ADMIN_ICONS_ARRAY,
    translationKey: 'table.header.permissions',
  },
} satisfies DataSchema;
